<template>
  <div class="flex flex-row items-center">
    <div
      class="flex items-center truncate min-h-full"
      :class="[selectionTextClass, { 'mr-2': !noArrow }]"
    >
      <slot />
    </div>
    <svg role="presentation" focusable="false" tabindex="-1" v-if="!noArrow"
       
      alt=""
      svg-inline
      :class="[`icon icon-xs ml-auto`, { 'rotate-180': open }]"
     xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19">
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    open: boolean
    noArrow?: boolean
    selectionTextClass?: string
  }>(),
  {
    selectionTextClass: 'font-bold text-18',
  },
)
</script>
